var _defs, _ellipse, _polyline, _path, _polyline2, _polyline3, _polyline4, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 54.76,
    cy: 55.01,
    rx: 49.81,
    ry: 50
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "35.03 9.08 40.19 21.68 19.15 20.04 20.57 41.59 28.19 55.01 35.52 73.35 40.93 87.94 35.12 100.97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.56,36.27l12,5.32,14.51-5.11-6.89,18.52-7.48,13.53-.98,22.01,21.2-2.61,13.47-6.22,18.95-8.22,14.21-5.18,17.01-13.31-17.16-13.71-13.92-4.52s-19.62-8-19.84-8.14-13.47-6.96-13.47-6.96L54.76,5.01l13.19,16.75,5.36-13.17"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "40.93 87.94 54.76 105.01 68.24 87.94 73.35 73.5 81.13 55.02 87.42 41.3 90.12 19.79 67.95 21.75 53.66 28.64 35.08 36.48 40.19 21.68"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "67.95 21.75 73.5 36.78 81.13 55.02 87.57 68.32 89.8 90.55 68.24 87.94 74.02 100.97"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "68.24 87.94 54.4 81.72 35.52 73.35 20.72 68.54 4.95 55.66 20.57 41.59"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 8.56,
    y1: 74.31,
    x2: 20.72,
    y2: 68.54
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 87.57,
    y1: 68.32,
    x2: 100.68,
    y2: 74.42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 87.42,
    y1: 41.3,
    x2: 100.62,
    y2: 35.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound);
export default __webpack_public_path__ + "static/media/round.2ed3aa42a2d0dfd7931dace8481e78e3.svg";
export { ForwardRef as ReactComponent };